import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PanelSection: FunctionComponent<Props> = ({
    children,
    className = '',
    count,
    rightSlot,
    testId = TEST_ID,
    text
}) => (
    <VerticalContainer className={`${styles.panelSection} ${className}`} testId={testId}>
        <HorizontalContainer className={styles.titleRow}>
            <Wrapper className={styles.titleWrapper}>
                <Wrapper className={styles.title}>{text}</Wrapper>

                {count !== undefined && <Wrapper className={styles.count}>({count})</Wrapper>}
            </Wrapper>

            {rightSlot && <Wrapper className={styles.rightSlot}>{rightSlot}</Wrapper>}
        </HorizontalContainer>

        {children && <Wrapper className={styles.body}>{children}</Wrapper>}
    </VerticalContainer>
);

export default PanelSection;
